import { render, staticRenderFns } from "./MetadatosTableView.vue?vue&type=template&id=b503e1e6"
import script from "./MetadatosTableView.vue?vue&type=script&lang=js"
export * from "./MetadatosTableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports